import { render, staticRenderFns } from "./ProcedimientosAdmin.vue?vue&type=template&id=2dc587aa&"
import script from "./ProcedimientosAdmin.vue?vue&type=script&lang=js&"
export * from "./ProcedimientosAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports